import React, { useState, useEffect } from "react";
import { Container, Navbar, Dropdown, Modal, Button, Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

// Icons
import { FaUnlock, FaLock, FaBell, FaMapMarkerAlt, FaBars } from "react-icons/fa";
import { FaLockOpen } from "react-icons/fa6";
import { RiFileList2Fill } from "react-icons/ri";
import { SiMicrosoftexcel } from "react-icons/si";

// Logos
import logo from "../images/TP-_logo-orizz-claim-color-white-text.png"; 
import logoInvert from "../images/sud-ricambi-logo-symbol-white.png";
import logoInvert2 from "../images/amotive-logo-symbol-inverted-cut.png";
import logoInvert3 from "../images/logo_proforma-removebg-preview (1).png";
import logoQlik from "../images/qlik2.png";

function BasicExample() {
  const [isLocked, setIsLocked] = useState(() => {
    const lockedState = localStorage.getItem("isLocked");
    return lockedState ? JSON.parse(lockedState) : true;
  });
  const [showMap, setShowMap] = useState(false);
  const [downloads, setDownloads] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const handleShowMap = () => setShowMap(true);
  const handleCloseMap = () => setShowMap(false);

  const filteredDownloads = downloads.filter((item) =>
    item.ragione_sociale?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const exportToExcel = () => {
    if (!downloads.length) return;
    const dataToExport = filteredDownloads.map((item) => ({
      "Ragione Sociale": item.ragione_sociale,
      "Nome File": item.nome_file,
      Data: new Date(item.quando).toLocaleDateString(),
    }));
    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Downloads");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "downloads.xlsx");
  };

  useEffect(() => {
    localStorage.setItem("isLocked", JSON.stringify(isLocked));
    let intervalId = isLocked 
      ? setInterval(() => (window.location.href = "/amotive"), 150000)
      : setInterval(() => window.location.reload(), 150000);
    return () => clearInterval(intervalId);
  }, [isLocked]);

  useEffect(() => {
    fetch("mancata_vendita_dashboard.json")
      .then((res) => res.json())
      .then((data) => { if (data?.TP?.download) setDownloads(data.TP.download); })
      .catch((err) => console.error(err));
  }, []);

  return (
    <Navbar
      expand="lg"
      className="ombra-dark m-3 mb-0 mt-2 px-4 py-2 border-0 custom-red-nav"
      style={{ 
        backgroundColor: "#b81f25 !important", 
        borderRadius: "50px", 
        minHeight: "60px" 
      }}
    >
      <Container fluid className="p-0">
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <img src={logo} alt="Logo" style={{ height: "30px", width: "auto" }} />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="navbar-responsive" className="border-0 shadow-none">
          <FaBars style={{ color: "white" }} />
        </Navbar.Toggle>

        <Navbar.Collapse id="navbar-responsive">
          <div className="d-flex flex-column flex-lg-row align-items-lg-center w-100 mt-3 mt-lg-0">
            
            <div className="d-flex flex-wrap align-items-center gap-3 ms-lg-4">
              <Link to="/ordini-urgenti" className="nav-link-white text-decoration-none">
                <RiFileList2Fill className="me-1 fs-5" /> ORDINI URGENTI
              </Link>
              <div className="v-separator-white d-none d-lg-block"></div>
              <Link to="/proforma" className="nav-link-white text-decoration-none">
                <img src={logoInvert3} alt="" className="brand-icon-white" /> PROFORMA
              </Link>
              <Link to="/sud-ricambi" className="nav-link-white text-decoration-none">
                <img src={logoInvert} alt="" className="brand-icon-white" /> SUD RICAMBI
              </Link>
              <Link to="/amotive" className="nav-link-white text-decoration-none">
                <img src={logoInvert2} alt="" className="brand-icon-white" /> AMOTIVE
              </Link>
            </div>

            <div className="d-flex align-items-center gap-3 ms-auto mt-3 mt-lg-0">
              
              {/* NOTIFICHE */}
              <Dropdown show={showDropdown} onToggle={() => setShowDropdown(!showDropdown)} align="end">
                <Dropdown.Toggle variant="transparent" className="border-0 p-0 position-relative shadow-none no-caret">
                  <div className="action-btn-glass circle-btn">
                    <FaBell />
                    {downloads.length > 0 && (
                      <Badge bg="white" text="danger" pill className="position-absolute top-0 start-100 translate-middle shadow-sm" style={{ fontSize: '0.6rem' }}>
                        {downloads.length}
                      </Badge>
                    )}
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu className="shadow-lg border-0 p-0 mt-3" style={{ width: "320px", borderRadius: "15px" }}>
                  {/* ... Contenuto Dropdown invariato ... */}
                  <div className="p-3 bg-light border-bottom rounded-top-4">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <span className="fw-bold small text-dark">DOWNLOAD RECENTI</span>
                        <Button variant="success" size="sm" onClick={exportToExcel} className="rounded-circle p-1 d-flex align-items-center justify-content-center">
                            <SiMicrosoftexcel />
                        </Button>
                    </div>
                    <input type="text" className="form-control form-control-sm rounded-pill border-0 shadow-sm" placeholder="Filtra..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                  </div>
                  <div style={{ maxHeight: "250px", overflowY: "auto" }} className="custom-scroll">
                    {filteredDownloads.map((item, index) => (
                      <div key={index} className="p-2 border-bottom hover-light transition-all px-3">
                        <div className="fw-bold text-dark truncate" style={{ fontSize: '0.75rem' }}>{item.ragione_sociale}</div>
                        <div className="text-muted truncate" style={{ fontSize: '0.65rem' }}>{item.nome_file}</div>
                      </div>
                    ))}
                  </div>
                </Dropdown.Menu>
              </Dropdown>

              {/* QLIK */}
              <a href="https://dashboard.technoparts.it/qlik/tp.html" target="_blank" rel="noreferrer" className="action-btn-glass text-decoration-none">
                <img src={logoQlik} alt="Qlik" style={{ width: "18px" }} />
                <span className="ms-2 d-none d-xl-inline">QLIK</span>
              </a>

              {/* MAPPA */}
              <button onClick={handleShowMap} className="action-btn-glass">
                <FaMapMarkerAlt />
                <span className="ms-2 d-none d-xl-inline">MAPPA</span>
              </button>

              <div className="v-separator-white d-none d-lg-block"></div>

              {/* LOCK BUTTON (Nuovo design simile agli altri) */}
              <button 
                onClick={() => setIsLocked(!isLocked)} 
                className={`action-btn-glass circle-btn ${isLocked ? 'btn-locked-active' : ''}`}
                title={isLocked ? "Sblocca Sessione" : "Blocca Sessione"}
              >
                {isLocked ? <FaLock /> : <FaLockOpen />}
              </button>
            </div>
          </div>
        </Navbar.Collapse>
      </Container>

      <style>{`
        .custom-red-nav { background-color: rgb(184, 31, 37) !important; }
        .no-caret::after { display: none !important; }

        .nav-link-white {
          color: rgba(255,255,255,0.9) !important;
          font-size: 0.75rem;
          font-weight: 600;
          display: flex;
          align-items: center;
          transition: 0.2s;
        }
        .nav-link-white:hover { color: #fff !important; transform: translateY(-1px); }
        
        .brand-icon-white { width: 20px; height: 20px; margin-right: 8px; filter: brightness(0) invert(1); }
        
        /* Stile comune per tutti i bottoni a destra */
        .action-btn-glass {
          background: rgba(255, 255, 255, 0.15);
          border: 1px solid rgba(255, 255, 255, 0.1);
          padding: 6px 14px;
          height: 36px;
          border-radius: 50px;
          color: white !important;
          font-size: 0.7rem;
          font-weight: 700;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        .action-btn-glass:hover { background: rgba(255, 255, 255, 0.25); border-color: rgba(255,255,255,0.3); transform: scale(1.05); }

        /* Varianti circolari per Bell e Lock */
        .circle-btn { width: 36px; padding: 0; border-radius: 50%; }

        /* Effetto quando il lock è attivo */
        .btn-locked-active {
            background: #fff !important;
            color: #b81f25 !important;
            border-color: #fff;
        }

        .v-separator-white { width: 1px; height: 20px; background: rgba(255,255,255,0.3); margin: 0 5px; }
        
        .hover-light:hover { background-color: #f8f9fa; cursor: pointer; }
        .truncate { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .ombra-dark { box-shadow: 0 4px 20px rgba(0,0,0,0.3); }
        .custom-scroll::-webkit-scrollbar { width: 4px; }
        .custom-scroll::-webkit-scrollbar-thumb { background: #ccc; border-radius: 10px; }

        #navbar-responsive {background-color: transparent !important; flex-direction: column; align-items: flex-start;}
      `}</style>
    </Navbar>
  );
}

export default BasicExample;